import { createContext, useContext } from "react";

const FolderScopeContext = createContext<number | null>(null);

export const useFolderScope = () => useContext(FolderScopeContext);

export const FolderScopeProvider = FolderScopeContext.Provider;
